const swiperSliderProgram = new Swiper('.slider__program__slider', {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 'auto',
    speed: 800,
    watchSlidesProgress: true,
    pagination: {
      el: ".slider__program-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".slider__program-next",
      prevEl: ".slider__program-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
    autoplay: {
      delay: 4000, 
      disableOnInteraction: false,
    },
});

const swiperSliderProgramFull = new Swiper('.slider__program__slider__full', {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 'auto',
    speed: 800,
    watchSlidesProgress: true,
    centeredSlides: true, 
    pagination: {
      el: ".slider__program-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 4000, 
      disableOnInteraction: false,
    },
});

